@if (showSelect) {
<mat-form-field id="mat-sort-field">
  <mat-label>Sort</mat-label>
  <mat-select
    [canSelectNullableOptions]="true"
    [disabled]="processing.disabled"
    [ngModel]="stateService.sort$ | async"
    (valueChange)="onSortValueChange($event)"
    mgdEnhancedControl
    #sortSelectControl="mgdEnhancedControl"
  >
    @if (isDefaultSort(stateService.sort$ | async)) {
    <mat-select-trigger>Default</mat-select-trigger>
    }
    @if (defaultOptionLabel()) {
    <mat-option [value]="undefined">
      {{ defaultOptionLabel() }}
    </mat-option>
    }
    @for (option of sortOptions; track option) {
    <mat-option [value]="option">
      {{ option.label }}
    </mat-option>
    }
  </mat-select>
  <mat-error><mgd-error-message [formField]="sortSelectControl"></mgd-error-message></mat-error>
</mat-form-field>
}